//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["dataConfig"],
  methods: {
    goBtnLink(item) {
      if (item.isRouter) {
        this.$router.push(item.link);
      } else {
        window.location.href = item.link;
      }
    },
    closePage() {
      WeixinJSBridge.call("closeWindow");
    }
  }
};
